import React, {memo, useMemo} from 'react';
import {LoadingOutlined} from '@ant-design/icons';
import {useTheme} from '@/contexts/ThemeContext';
import PropTypes from 'prop-types';

const Loading = ({className}) => {
  const {theme} = useTheme();

  const color = useMemo(() => theme?.general?.primaryColor, [theme]);

  return (
    <LoadingOutlined className={className} style={{color}}/>
  );
};

Loading.propTypes = {
  className: PropTypes.string
};

Loading.defaultProps = {
  className: 'text-6xl'
};

export default memo(Loading);
